import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Profile screen imports
import ProfileScreen from '../../screens/profile/ProfileScreen';
import EditProfileScreen from '../../screens/profile/EditProfileScreen';
import ProfilePictureSelectScreen from '../../screens/profile/ProfilePictureSelectScreen';
import ChangePasswordScreen from '../../screens/profile/ChangePasswordScreen';
import SettingsScreen from '../../screens/profile/SettingsScreen';
import NotificationsScreen from '../../screens/profile/NotificationsScreen';
import DeleteDataScreen from '../../screens/profile/DeleteDataScreen';
import DeleteAccountScreen from '../../screens/profile/DeleteAccountScreen';
import LanguageSettingsScreen from '../../screens/profile/LanguageSettingsScreen';
import BiometricSettingsScreen from '../../screens/profile/BiometricSettingsScreen';
import IdleLockSettingsScreen from '../../screens/profile/IdleLockSettingsScreen';
import RecoveryCodeSettingsScreen from '../../screens/profile/RecoveryCodeSettingsScreen';
import SetRecoveryCodeIntroScreen from '../../screens/profile/SetRecoveryCodeIntroScreen';
import SetRecoveryCodeInputScreen from '../../screens/profile/SetRecoveryCodeInputScreen';
import SetRecoveryCodeSuccessScreen from '../../screens/profile/SetRecoveryCodeSuccessScreen';
import ChangeRecoveryCodeScreen from '../../screens/profile/ChangeRecoveryCodeScreen';
import ErrorLogsScreen from '../../screens/profile/ErrorLogsScreen';
import AboutScreen from '../../screens/profile/AboutScreen';
import ChangelogScreen from '../../screens/profile/ChangelogScreen';
import SubscriptionManagementSceen from '../../screens/profile/SubscriptionManagementScreen';
import UpgradeScreen from '../../screens/profile/UpgradeScreen';
import UpdatePaymentScreen from '../../screens/profile/UpdatePaymentScreen';
import LinkedAccountsScreen from '../../screens/profile/LinkedAccountsScreen';
import MyPrioritiesScreen from '../../screens/profile/MyPrioritiesScreen';
import ReferAFriendScreen from '../../screens/profile/ReferAFriendScreen';
import FamilyPlanScreen from '../../screens/profile/FamilyPlanScreen';

// Successor management screens
import AddSuccessorScreen from '../../screens/profile/AddSuccessorScreen';
import SuccessorDetailsScreen from '../../screens/profile/SuccessorDetailsScreen';

// KeyHolder management screens
import AddKeyHolderScreen from '../../screens/profile/AddKeyHolderScreen';
import KeyHolderDetailsScreen from '../../screens/profile/KeyHolderDetailsScreen';

// Trusted-party async handshake (medium-term #2)
import PendingConnectionsScreen from '../../screens/profile/PendingConnectionsScreen';

// Legal screens
import PrivacyPolicyScreen from '../../screens/profile/PrivacyPolicyScreen';
import TermsOfServiceScreen from '../../screens/profile/TermsOfServiceScreen';

// Death Certificate / Full Access screens
import { RequestFullAccessScreen } from '../../screens/profile/RequestFullAccessScreen';
import { SecretCodeScreen } from '../../screens/profile/SecretCodeScreen';

// Access Management
import { AccessChecklistScreen } from '../../screens/access-checklist/AccessChecklistScreen';

// Death Verification Settings
import SecretCodeRecipientsScreen from '../../screens/profile/SecretCodeRecipientsScreen';
import DeathAccessPolicyScreen from '../../screens/profile/DeathAccessPolicyScreen';

const Stack = createNativeStackNavigator();

export const ProfileNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      initialRouteName="Settings"
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Profile & Settings Screens */}
      <Stack.Screen name="Settings" component={SettingsScreen} />
      <Stack.Screen name="ProfileDetails" component={ProfileScreen} />
      <Stack.Screen name="EditProfile" component={EditProfileScreen} />
      <Stack.Screen name="ProfilePictureSelect" component={ProfilePictureSelectScreen} />
      <Stack.Screen name="ChangePassword" component={ChangePasswordScreen} />
      <Stack.Screen name="Notifications" component={NotificationsScreen} />
      <Stack.Screen name="DeleteData" component={DeleteDataScreen} />
      <Stack.Screen name="DeleteAccount" component={DeleteAccountScreen} />
      <Stack.Screen name="LanguageSettings" component={LanguageSettingsScreen} />
      <Stack.Screen name="BiometricSettings" component={BiometricSettingsScreen} />
      <Stack.Screen name="IdleLockSettings" component={IdleLockSettingsScreen} />
      <Stack.Screen name="RecoveryCodeSettings" component={RecoveryCodeSettingsScreen} />
      <Stack.Screen name="SetRecoveryCodeIntro" component={SetRecoveryCodeIntroScreen} />
      <Stack.Screen name="SetRecoveryCodeInput" component={SetRecoveryCodeInputScreen} />
      <Stack.Screen name="SetRecoveryCodeSuccess" component={SetRecoveryCodeSuccessScreen} />
      <Stack.Screen name="ChangeRecoveryCode" component={ChangeRecoveryCodeScreen} />
      <Stack.Screen name="ErrorLogs" component={ErrorLogsScreen} />
      <Stack.Screen name="About" component={AboutScreen} />
      <Stack.Screen name="Changelog" component={ChangelogScreen} />
      <Stack.Screen name="SubscriptionManagement" component={SubscriptionManagementSceen} />
      <Stack.Screen name="Upgrade" component={UpgradeScreen} />
      <Stack.Screen name="UpdatePayment" component={UpdatePaymentScreen} />
      <Stack.Screen name="LinkedAccounts" component={LinkedAccountsScreen} />
      <Stack.Screen name="MyPriorities" component={MyPrioritiesScreen} />
      <Stack.Screen name="ReferAFriend" component={ReferAFriendScreen} />
      <Stack.Screen name="FamilyPlan" component={FamilyPlanScreen} />

      {/* Successor Management */}
      <Stack.Screen name="AddSuccessor" component={AddSuccessorScreen} />
      <Stack.Screen name="SuccessorDetails" component={SuccessorDetailsScreen} />

      {/* KeyHolder Management */}
      <Stack.Screen name="AddKeyholder" component={AddKeyHolderScreen} />
      <Stack.Screen name="KeyHolderDetails" component={KeyHolderDetailsScreen} />

      {/* Trusted-party async handshake (medium-term #2) */}
      <Stack.Screen name="PendingConnections" component={PendingConnectionsScreen} />

      {/* Access Management */}
      <Stack.Screen name="AccessChecklist" component={AccessChecklistScreen} />

      {/* Legal Screens */}
      <Stack.Screen name="PrivacyPolicy" component={PrivacyPolicyScreen} />
      <Stack.Screen name="TermsOfService" component={TermsOfServiceScreen} />

      {/* Death Certificate / Full Access */}
      <Stack.Screen name="RequestFullAccess" component={RequestFullAccessScreen} />
      <Stack.Screen name="SecretCode" component={SecretCodeScreen} />

      {/* Death Verification Settings */}
      <Stack.Screen name="SecretCodeRecipients" component={SecretCodeRecipientsScreen} />
      <Stack.Screen name="DeathAccessPolicy" component={DeathAccessPolicyScreen} />
    </Stack.Navigator>
  );
};

export default ProfileNavigator;